import { useForm } from 'react-hook-form'
import toast from 'react-hot-toast'
import { yupResolver } from '@hookform/resolvers/yup'
import { fetchFtpProfile, updateFtpProfile } from 'utils/api/ftpProfileApi'
import { PAGE_NOT_FOUND, PAGE_FTP_PROFILE } from 'utils/constants'
import { Button, Spinner } from 'components/common'
import { FtpProfileDetailsForm } from 'components/ftpProfiles'
import { FtpProfileFormData } from 'components/ftpProfiles/utils'
import BackButton from 'components/backButton'
import { useNavigate, useParams } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { updateFtpProfileSchema } from 'utils/schema/ftpProfileSchema'
import { handleError } from 'utils/helpers/handleError'

const UpdateFtpProfile = () => {
  const navigate = useNavigate()
  const { id } = useParams()
  const [loading, setLoading] = useState<boolean>(true)
  const [ftpProfile, setFtpProfile] = useState<any>({})

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    control,
    formState: { errors },
  } = useForm<FtpProfileFormData>({
    resolver: yupResolver(updateFtpProfileSchema),
  })

  const getFtpProfileDetails = async (id: string) => {
    try {
      const { data } = await fetchFtpProfile(id)
      setFtpProfile(data)
      delete data._id
      reset(data)
    } catch (error) {
      setFtpProfile({})
      navigate(PAGE_NOT_FOUND.path)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (id) {
      getFtpProfileDetails(id)
    }
  }, [])

  if (loading) {
    return <Spinner />
  }

  const handleUpdateFtpProfile = async (data: FtpProfileFormData) => {
    if (!id) return

    const toastFtpProfile = toast.loading('Updating FTP profile...', {
      duration: Infinity,
    })

    try {
      await updateFtpProfile(id, data)

      toast.success('FTP profile updated successfully!', {
        id: toastFtpProfile,
        duration: 3000,
      })

      reset()
      navigate(PAGE_FTP_PROFILE.path)
    } catch (error) {
      handleError(error, toastFtpProfile, {
        default: 'Failed to update FTP profile!',
      })
    }
  }

  return (
    <>
      <BackButton />

      <form onSubmit={handleSubmit(handleUpdateFtpProfile)}>
        <FtpProfileDetailsForm
          register={register}
          errors={errors}
          setValue={setValue}
          control={control}
          ftpProfile={ftpProfile}
          isOptional
        />

        <Button buttonText="Update FTP Profile" className="mt-7 w-44" />
      </form>
    </>
  )
}

export default UpdateFtpProfile
